import { render, staticRenderFns } from "./ns-alert-popup.vue?vue&type=template&id=6441c1f0&"
import script from "./ns-alert-popup.vue?vue&type=script&lang=js&"
export * from "./ns-alert-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports